export default __webpack_public_path__ + "static/media/goopter-movie-theatres-features-highlights.b584efb0.jpg";